<template>
    <div class="promo-code-area">
        <a @click="code_modal = true;" class="button danger" href="javascript:;">
            <svg viewBox="0 0 48 48"> <g id="Layer_2" data-name="Layer 2"> <g id="invisible_box" data-name="invisible box"> <rect width="48" height="48" fill="none"/> </g> <g id="Icons"> <path d="M46,15a2.9,2.9,0,0,0-3-3H38.3a4.2,4.2,0,0,0,.4-1,7,7,0,0,0-.6-5.3,6.7,6.7,0,0,0-4.3-3.4A7.1,7.1,0,0,0,25,7l-1,3.4L23,7a7.1,7.1,0,0,0-8.8-4.7A6.7,6.7,0,0,0,9.9,5.7,7,7,0,0,0,9.3,11a4.2,4.2,0,0,0,.4,1H5a2.9,2.9,0,0,0-3,3V26H4V43a2.9,2.9,0,0,0,3,3H41a2.9,2.9,0,0,0,3-3V26h2Zm-4,7H31V16H42ZM21,22V16h6v6Zm6,4V42H21V26ZM32.7,6.1a3.2,3.2,0,0,1,1.9,1.5,2.9,2.9,0,0,1,.3,2.2,3.1,3.1,0,0,1-3,2.2H27.7l1.1-3.8A3.3,3.3,0,0,1,32.7,6.1ZM13.1,9.8a2.9,2.9,0,0,1,.3-2.2,3.2,3.2,0,0,1,1.9-1.5,3.3,3.3,0,0,1,3.9,2.1L20.3,12H16.1A3.1,3.1,0,0,1,13.1,9.8ZM6,16H17v6H6ZM8,26h9V42H8ZM40,42H31V26h9Z"/> </g> </g> </svg>
            Etkinlik Kodu
        </a>
        <div class="code-modal">
            <Modal :isVisible="code_modal" >
                <template slot="content">
                    <div class="close-btn button primary" @click="code_modal = false;type = ''">
                        <svg xmlns="http://www.w3.org/2000/svg" height="329pt" viewBox="0 0 329.26933 329" width="329pt"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
                    </div>
                    <h3>
                        Etkinlik Kodu Gir
                    </h3>
                    <div class="alert">
                        Etkinlik Kodu kullanmanız taktirde Etkinlik Kodu detaylarını okumuş, anlamış ve kabul etmiş sayılacaksınız.
                    </div>
                    <input type="text" v-model="code" step="width:100%" placeholder="Etkinlik kodunuzu giriniz">
                    <br><br>
                    <ButtonLoader style="width:100%;height: 40px;" :loader="isLoading" @click.native="onSubmit" class="button primary" :text="'Kodu Gir'">
                        <template name="icon">
                            <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                        </template>
                    </ButtonLoader>
                </template>
            </Modal>
        </div>
    </div>
</template>
<script>
	import RequestPage from './Request.vue'
	export default{
		data(){
			return{
                code:null,
                code_modal: false,
                isLoading:false
			}
		},
            watch:{
            code_modal(val){
                if(val){
                document.querySelector("#app").classList.add('lock');
                }else{
                document.querySelector("#app").classList.remove('lock');
                }
            }
        },
		components:{
		},
		computed:{
		},
		created(){
			
		},
		methods:{
            onSubmit(evt){
                this.isLoading = true;
                axios.post('/user/request/promotion', {promotion_code : this.code})
                    .then((response)=>{
                    if(response.data.status){
                        this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
                    }else{
                        this.$store.dispatch('alert/message', { type: 'error', msg: response.data.message })
                    }
                    this.code_modal = false
                })
                .catch((err)=>{
                    this.error = err.response.data.message 
                })
                .finally(()=>{
                    this.isLoading = false;
                })
            },
		}
	}
</script>

<style lang="scss">
    #app.mobile{
        .promo-code-area{
            .button:not(.close-btn){
                height: 40px !important;
                border-radius: 10px;
            }
        }
        .code-modal{
            .content{
                height: 100% !important;
                max-height: none !important;
                border-radius: 0px !important;
                .button:not(.close-btn){
                    width: 100% !important;
                }
            }
        }
    }
    #app:not(.mobile) .inc{
        .code-modal{
            .content{
                width: 320px !important;
            }
        }
    }
    .promo-code-area{
        .button:not(.close-btn){
            svg{
                width: 15px;
                height: 15px;
                margin-right: 5px;
            }
        }
    }
    .code-modal{
        .content{
            height: auto !important;
            color:#fff;
            .alert{
                text-align: left;
                background: rgb(255 255 255 / 8%);
                margin: 10px 0;
                font-weight: bold;
                span{
                    color: var(--client-c3)
                }
            }
            .close{
                display: none !important;
            }
            .close-btn{
                position: absolute;
                right: 10px;            
                width: 30px;
                top: 10px;
                border-radius: 100%;
                height: 30px;
                padding: 0px !important;
                svg{
                    width: 10px;
                    height: 10px;
                }    
            }
        }
    }
</style>